import { observer } from "mobx-react-lite";
import { KnowledgeCardOption } from "../../../components/Home/KnowledgeCenter/Card/KnowledgeCard";
import ConsoleKnowledgeCenter from "../../../components/Home/KnowledgeCenter/ConsoleKnowledgeCenter";

const ImageEditingKnowledge = () => {
	const cards: KnowledgeCardOption[] = ["REMOVE_BG", "ERASER"];

	return <ConsoleKnowledgeCenter cards={cards} />;
};

export default observer(ImageEditingKnowledge);
